import React from 'react';
import './primitives.css';

export type BadgeTone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  readonly tone?: BadgeTone;
  readonly dot?: boolean;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly 'data-testid'?: string;
}

/** SLDS-styled status pill. Token-driven; tone maps to a semantic colour pair. */
export function Badge({
  tone = 'neutral',
  dot,
  children,
  className,
  ...rest
}: BadgeProps): React.ReactElement {
  return (
    <span className={['tl-badge', `tl-badge--${tone}`, className ?? ''].filter(Boolean).join(' ')} {...rest}>
      {dot && <span className="tl-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
